module.exports = __webpack_public_path__ + "img/animation_error.c4ee96c0.gif";